import { DB_DATETIME_FORMAT_STRING } from 'app/helpers/parseDate';
import { startCase, toLower } from 'lodash-es';
import moment from 'moment';

export const getReportLinkByState = (state: string, reportId: string, type: 'agency' | 'client'): string => {
  if (type === 'agency') {
    const linkSection = state === 'confirmed_booking' || state === 'confirmed' ? 'confirmed-jobs' : 'previous-jobs';

    return `/agency/bookings/${linkSection}/report/${reportId}`;
  } else {
    const linkSection =
      state === 'confirmed_booking' || state === 'confirmed' ? 'confirmed-bookings' : 'previous-bookings';

    return `/client/bookings/${linkSection}/report/${reportId}`;
  }
};

export const titleCaseName = (name: string): string => {
  return startCase(toLower(name));
};

export const getDashboardDate = (date: string): string => {
  return moment(date).format('MMM D, YYYY');
};

export const getDashboardTime = (time: string): string => {
  return moment(time, 'HH:mm').format('h:mm a');
};

export const getDashboardDateTime = (dateTime: string): string | null => {
  return moment(dateTime, DB_DATETIME_FORMAT_STRING).format('dddd, MMM D, YYYY h:mm a');
};

export const getDashboardDateRange = (startDate: string, endDate: string): string => {
  const date = getDashboardDate(startDate);
  let dateRange = '';
  if (endDate && endDate !== startDate) {
    dateRange = '+';
  }
  return `${date} ${dateRange}`;
};

export const getStatus = (state?: string, role?: string): string => {
  switch (state) {
    case 'new':
      return 'New';
    case 'past':
      return 'Completed';
    case 'cancelled_by_client':
      return role === 'client' ? 'Cancelled by You' : 'Cancelled by Client';
    case 'cancelled_by_agency':
      return role !== 'client' ? 'Cancelled by You' : 'Cancelled by Agency';
    case 'cancelled_by_admin':
      return 'Cancelled by Admin';
    case 'confirmed_booking':
      return 'Confirmed';
    default:
      return 'Past';
  }
};
